import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/customer/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/customer/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/customer/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/customer/delete/${id}`)
}

// 重置密码
export function reset (data) {
  return request.post('/customer/password/reset', data)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/customer/delete/batch', {
    params: {
      ids
    }
  })
}
